import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'store-info-cards',
  templateUrl: './store-info-cards.component.html',
  styleUrls: ['./store-info-cards.component.scss']
})
export class StoreInfoCardsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
